module.exports = __webpack_public_path__ + "media/landing-page/como-funciona-2-535af4f9.svg";